import { connect } from 'react-redux'
import PieModule from '../Modules/Pie'
import { AUTHEN_TOKEN } from '../../../constants/define'
import { getNumberOfVisits } from '../../../api/analytic'

class NumberVisitStamp extends PieModule {
  getAuthenToken = () => {
    return localStorage.getItem(AUTHEN_TOKEN)
  }

  callApi = (...arg) => {
    return getNumberOfVisits(...arg)
  }

  getTitle = () => {
    const language = this.getLanguage()
    return language.t('dashboard.number_of_visit')
  }

  getLanguage = () => {
    const { language } = this.props
    return language
  }
}

const mapState = state => {
  return {
    language: state.languageReducer.language,
  }
}

export default connect(mapState)(NumberVisitStamp)
